import { datadogRum } from "@datadog/browser-rum";

const initializeDatadog = () => {
  // Access environment variables passed from server via window.PUBLIC_ENV
  const publicEnv = window.PUBLIC_ENV || {};

  // We only want to initialize Datadog RUM in beta and prod environments
  if (!["beta", "prod"].includes(publicEnv.PS_ENV || "")) {
    return;
  }

  // Require environment variables to be set - fail early if missing
  if (
    !publicEnv.DATADOG_RUM_APPLICATION_ID ||
    !publicEnv.DATADOG_RUM_CLIENT_TOKEN
  ) {
    return;
  }

  // These 3rd party domains are injected by Segment and throw CORS error
  const blockedDomains = ["ct.pinterest.com", "s.pinimg.com"];

  datadogRum.init({
    applicationId: publicEnv.DATADOG_RUM_APPLICATION_ID,
    clientToken: publicEnv.DATADOG_RUM_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    service: "web-2",
    env: publicEnv.PS_ENV,
    version: publicEnv.RELEASE_TAG,
    allowedTracingUrls: [
      {
        match: /^https?:\/\/.*\.peerspace\.com.*/, // Track internal API calls to peerspace.com
        propagatorTypes: ["tracecontext", "datadog"], // W3C traceparent + Datadog headers
      },
      {
        match: /^https?:\/\/.*\.peerspaceapp\.com.*/, // Track internal API calls to peerspaceapp.com
        propagatorTypes: ["tracecontext", "datadog"], // W3C traceparent + Datadog headers
      },
    ],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    trackBfcacheViews: true,
    trackUserInteractions: true,
    trackResources: true,
    enablePrivacyForActionName: true,
    silentMultipleInit: true,
    propagateTraceBaggage: true,
    beforeSend: (event) => {
      // Drop fetch failures from third-party tracking/analytics domains (ad blockers)
      if (
        event.type === "error" &&
        event.error?.message === "Failed to fetch" &&
        typeof event.error?.stack === "string"
      ) {
        if (
          blockedDomains.some((domain) => event.error?.stack?.includes(domain))
        ) {
          return false;
        }
      }
      return true;
    },
  });
};;

export { initializeDatadog };
